<template>
  <div>
    <div
      v-for="(item, itemIndex) in attachments"
      :key="'attachment-Index-'+itemIndex"
      class="attachment-item-row"
    >
      <div class="attachment-item pa-2">
        <div class="attachment-item-value">
          <v-icon left>
            mdi-file-pdf
          </v-icon>
          {{ item.fileName }}
        </div>
      </div>
      <div class="attachment-item pa-2">
        <div class="attachment-item-value">
          <div class="attachment-item-value">
            {{ item.fileSize }}
          </div>
        </div>
      </div>
      <div class="attachment-item pa-2">
        <div class="attachment-item-value">
          <div class="attachment-item-value">
            <v-btn
              class="attachment-remove-btn"
              color="red"
              icon
              small
              @click="
                activeAttachment = itemIndex;
                deleteConfirmationVisibility = true
              "
            >
              <v-icon color="var(--app-dark-primary-color)">
                mdi-delete
              </v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <naj-confirmation
      :show-modal="deleteConfirmationVisibility"
      color="error"
      :title="local.common.removeConfirmation"
      :message="removeMessage"
      :ok-btn-label="local.common.remove"
      @ok="() => deleteAttachment()"
      @cancel="hideDeleteModal"
    ></naj-confirmation>
  </div>
</template>

<script>

export default {
  name: 'AttachmentList',
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeAttachment: null,
      deleteConfirmationVisibility: false,
    };
  },
  computed: {
    removeMessage() {
      return this.local.common.dynamicRemoveConfirmationMessage(this.local.attachments.attachment);
    },
  },
  methods: {
    deleteAttachment() {
      this.attachments.splice(this.activeAttachment, 1);
      this.deleteConfirmationVisibility = false;
    },
    hideDeleteModal() {
      this.attachmentKey = null;
      this.objectKey = null;
      this.deleteConfirmationVisibility = false;
    },
    showDeleteModal({ attachmentKey, objectKey }) {
      this.attachmentKey = attachmentKey;
      this.objectKey = objectKey;
      this.deleteConfirmationVisibility = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.attachment-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}
.attachment-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: var(--app-dark-primary-color);
}
</style>
